export function parseProductIdFromPath(path) {
    const p = path.split('/')
    return p[p.length - 1]
}

export function parseQueryFromPath(path) {
    const p = path.split('/')
    return p[p.length - 1]
}

export function nowTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function nowTimeDay() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function logInfo(text) {
    console.log(`[${nowTime()}] ${text}`);
}

export function logError(text) {
    console.log(`[${nowTime()}] [Error] ${text}`);
}

export function isEmptyObject(obj) {
    if (obj === null || obj === undefined) {
        return true;
    }
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}